import { Batch, BatchWithoutId } from '@paragon/contract-library';

import { DesignService } from '../connections';

export function getAll(): Promise<readonly Batch[]> {
  return DesignService.get(`public/batches`);
}

export function getForProductionGroup(productionGroupGuid: string): Promise<readonly Batch[]> {
  return DesignService.get(`public/batches/forProductionGroup/${productionGroupGuid}`);
}

export function insert(batch: BatchWithoutId): Promise<Batch> {
  return DesignService.post('public/batches', { data: batch });
}

export function remove(batchGuid: string): Promise<void> {
  return DesignService.delete(`public/batches/${batchGuid}`);
}
